import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  infoTab: {},
  row: {
    display: 'flex',
    marginBottom: '25px',
  },
  infoBlock: { width: '100%' },
  title: {
    color: theme.palette.text.disabled,
  },
  editField: {
    padding: '9px',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'space-between',
    paddingTop: '10px',
  },
  editButton: {},
  value: {
    wordWrap: 'break-word',
  },
}));

export default useStyles;
